
    import {IPage} from "@/js/page";
    import {Component, Vue, Watch} from "vue-property-decorator";

    import {rulesApi} from "@/api/rules";
    import {fileApi, userApi} from "@/api/organization";
    import baseUrl from "@/constants";
    import SetTableColumns from "@/components/SetTableColumns.vue"
    import {instrumentApi} from "@/api/instrument";
    import echarts from "echarts";


    @Component({
        name: "rulesList",
        components: {SetTableColumns}
    })
    export default class Home extends Vue {
        rulesType = '0'; //type 0 地方 1国家 2共享 3其它  100总量统计 101年发布量统计 200统计
        tempType = '2';
        title = "";
        showForm = false;
        rulesName = '';
        listData = [];
        listParam: IPage = {
            size: 10,
            current: 1,
        };
        propParams = {
            name: '',
            number: '',
            releaseOffice: '',
            releaseStartTime: '',
            releaseEndTime: '',
            implementStartTime: '',
            implementEndTime: '',
            implementRegion: '',
            currentStatus: '',
            replaceRules: '',
            beReplaceRules: '',
            draftUnitNum: '',
            drafterNum: '',
        } as any;
        mode = 0;
        listTotal = 0;
        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        tabCol = [];
        load = false;
        modeType = "0";
        modeTypeChart = "0";  //地图查询条件 0地方 1国家
        countData = {
            all: 0,
            country: 0,
            local: 0
        }
        allSelected = [];
        rulesEdit = false;
        shareRelease = false;
        moduleText = "";
        myChart = null as any;
        fullScreen = false;
        downloadRuleEnclosure = false;
        tableKey = 0;

        created() {
            if(this.$route.path == "/statistics/rulesChartAll/lists/200"){
                this.fullScreen = true;
            }
            const route = this.$route;
            const q = JSON.parse(JSON.stringify(route.query));
            if (q.size) {
                this.listParam.size = Number(q.size);
                this.listParam.current = Number(q.current);
            }
            for (const f in this.propParams) {
                if (q[f]) this.propParams[f] = q[f];
            }
            this.mode = Number(this.$route.params.mode);
            this.rulesType = route.params.type;
            const arr = this.$route.path.split('/');
            if(arr.length > 1){
                this.moduleText = '/'+arr[1];
            }
            this.$nextTick(()=>{
                this.handleClick2();
                if(this.fullScreen){
                    this.refresh();
                }else{
                    this.haveRight();
                    this.updateTitle();
                    this.getConfig(true);
                }
            })
        }
        activated(){
            if (this.$route.meta && !this.$route.meta.isBack) {
                this.showForm = false;
                this.reset();
            }else{
                this.list();
            }
            this.tableClearSelect();
        }
        tableClearSelect(){
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            if($table){
                $table.clearSelection();
            }
        }
        reset(){
            for(const f in this.propParams){
                this.propParams[f] = "";
            }
            this.refresh();
        }
        haveRight(){
            const right = this.$store.state.userRights;
            right.forEach((e:any)=>{
                if(e.name == "rules_edit" && this.rulesType == '0'){ //地方规程编辑
                    this.rulesEdit = true;
                }
                if(e.name == "country_rules_edit" && this.rulesType == '1'){ //国家规程编辑
                    this.rulesEdit = true;
                }
                if(e.name == "share_release" && this.rulesType == '2'){ //规程发布
                    this.shareRelease = true;
                }
                if(e.name == "other_rules_edit" && this.rulesType == '3'){ //其它规程编辑
                    this.rulesEdit = true;
                }
                if(e.name == "download_rule_enclosure"){
                    this.downloadRuleEnclosure = true;
                }
            })
        }
        getConfig(refresh: boolean) {
            userApi.getUserConfig({name: this.rulesName + "PageSize"}).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    if (rData) {
                        this.listParam.size = Number(rData.config);
                    }
                    if (refresh) this.refresh();
                }
            })
        }

        changeTabCol(e: any) {
            this.tabCol = e;
            this.$nextTick(()=>{
                let $table = this.$refs.table as HTMLFormElement;
                if($table){
                    $table.doLayout();
                }
                this.tableKey = Math.random();
            })
        }

        //0新增  1编辑 2查看  3删除
        edit(type: number) {
            const dataArr = this.allSelected as any;
            let id = 0;
            if(type !== 0){
                if(dataArr.length == 0){
                    this.$message.error("请先勾选");
                    return;
                }
                if(type == 3){
                    this.del(dataArr);
                    return;
                }
                if(dataArr.length > 1 && (type == 1 || type == 2)){
                    this.$message.error("只能勾选一条");
                    return;
                }
                id = dataArr[0].id;
                this.$router.push(this.moduleText+"/Detail"+(this.fullScreen?'s':'')+"/" + id + "/" + type+"/"+(dataArr[0].type==2?3:dataArr[0].type));
            }else{
                this.$router.push(this.moduleText+"/Detail"+(this.fullScreen?'s':'')+"/" + id + "/" + type+"/"+this.rulesType);
            }
        }
        detail(data: any) {
            let id = data.id;
            this.$router.push(this.moduleText+"/Detail"+(this.fullScreen?'s':'')+"/" + id + "/2/" + (data.type==2?3:data.type));
        }

        down(row: any) {
            try {
                var obj=JSON.parse(row);
                if(typeof obj == 'object' && obj ){
                    if(this.downloadRuleEnclosure){
                        window.open(baseUrl + "/file/download?file=" + obj[0].url + "&name=" + obj[0].name, '_blank');
                    }else{
                        const router = this.$router.resolve({path: '/pdfviewer', query: {'pdfurl': encodeURI(obj[0].url)}});
                        window.open(router.href,'_blank');
                    }
                    return true;
                }else{
                    return false;
                }
            } catch(e) {
                window.open(baseUrl + "/file/download?file=" + row + "&name=" + this.title + "影印件", '_blank');
                return false;
            }
        }

        updateTitle() {
            switch(this.rulesType){
                case '0':
                    this.title = "地方规程规范管理";
                    break;
                case '1':
                    this.title = "国家规程规范管理";
                    break;
                case '2':
                    this.title = "规程规范共享管理";
                    break;
                case '3':
                    this.title = "其他规程规范管理";
                    break;
                case '100':
                    this.title = "规程规范总量统计";
                    break;
                case '101':
                    this.title = "规程规范年发布量统计";
                    break;
                case '200':
                    this.title = "规程规范统计";
                    break;
                default:
                    this.title = "";
            }
            this.rulesName = "rules";
            // this.rulesName = this.rulesType == 2 ? "rules" : (this.rulesType == 0 ? "rules0" : "rules1");
            if(this.rulesType == '2'){
                this.getCount();
            }
        }
        getCount(){
            rulesApi.count(1).then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    this.countData = rData;
                }
            })
        }
        handleClick() {
            this.allSelected = [];
            let $table = this.$refs.table as HTMLFormElement;
            $table.clearSelection();
            this.refresh();
        }

        @Watch("rulesType")
        getRulesType(){
            if(this.rulesType == '200'){
                this.$set(this,"rulesType",'100');
                return;
            }
            this.handleClick2();
        }

        handleClick2(){
            if(this.rulesType == '100'){
                this.getData();
            }else if(this.rulesType == '101'){
                this.getData2();
            }
        }
        list() {
            const route = this.$route;
            this.updateTitle()
            if (this.rulesType != this.tempType && !this.fullScreen) {
                this.getConfig(false);
                for(const f in this.propParams){
                    this.propParams[f] = "";
                }
                this.tempType = this.rulesType
            }
            let q = JSON.parse(JSON.stringify(route.query));
            q = Object.assign(q, this.listParam, this.propParams);
            for (const key in q) {
                q[key] = String(q[key]);
            }
            // if(JSON.stringify(q) != JSON.stringify(route.query)) {
            //     this.$router.replace({name: route.name!, query: q})
            // }


            const params = {
                ...this.listParam,
                ...this.propParams,
                type: this.rulesType,
            }

            if(this.rulesType == '2'){
                if(this.modeType == "0"){
                    params.type = this.shareRelease ? null : "1";
                    params.status = this.shareRelease ? null : 1;
                }else if(this.modeType == "1"){
                    params.status = 1;
                    params.type = 1;
                }else if(this.modeType == "2"){
                    params.status = 1;
                    params.type = 0;
                }
            }else{
                params.type = this.trueRulesType();
            }
            this.load = false;
            rulesApi.page(params).then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data.records;
                    this.listTotal = r.data.data.total;
                    rData.map((e: any) => {
                        if (e.enclosure) {
                            e.enclosureArr = e.enclosure.split(",");
                        } else {
                            e.enclosureArr = [];
                        }
                        e.draftUnitNum = e.draftUnit&&JSON.parse(e.draftUnit)[0].name ? JSON.parse(e.draftUnit).length : 0;
                        e.drafterNum = e.drafter&&JSON.parse(e.drafter)[0].name ? JSON.parse(e.drafter).length : 0;
                        e.draftUnitNum += (e.draftUnitPart&&JSON.parse(e.draftUnitPart)[0].name ? JSON.parse(e.draftUnitPart).length : 0);
                        e.drafterNum += (e.drafterPart&&JSON.parse(e.drafterPart)[0].name ? JSON.parse(e.drafterPart).length : 0);
                    })
                    this.listData = rData;
                }
                this.$nextTick(() => {
                    this.load = true;
                    let $table = this.$refs.table as HTMLFormElement;
                    if($table){
                        $table.doLayout();
                    }
                })
            })

        }

        pageSizeChange(val: number) {
            this.listParam.size = val;
            this.refresh();
            userApi.updateUserConfig({name: this.rulesName + "PageSize", config: val})
        }

        pageCurrentChange(val: number) {
            this.listParam.current = val;
            this.list();
        }

        checkboxInit(row: any, index: number) {
            if (row.result) {
                return 0;//0不可勾选
            } else {
                return 1;//1可勾选
            }
        }

        indexMethod(index: any) {
            return (this.listParam.current - 1) * this.listParam.size + index + 1;
        }

        refresh() {
            this.listParam.current = 1;
            this.list();
        }

        memberSelect(selection: any, row: any) {
            this.allSelected = selection;
        }
        share(){
            const dataArr = this.allSelected as any;
            if(dataArr.length == 0){
                this.$message.error("请先勾选");
                return
            }
            this.$confirm('确定要共享'+dataArr.flatMap((e:any)=>e.name).join(",")+'？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                rulesApi.updateReleaseStatus( dataArr.flatMap((e:any)=>e.id).join(","),1).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("共享成功");
                        this.handleClick();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

        // @Watch("$route.path")
        // get$routePath() {
        //     this.mode = Number(this.$route.params.mode);
        //     this.refresh();
        //     this.haveRight();
        // }

        del(dataArr: any){
            this.$confirm('确定要删除'+dataArr.flatMap((e:any)=>e.name).join(",")+'？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                rulesApi.delete(dataArr.flatMap((e:any)=>e.id).join(",")).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("删除成功");
                        this.handleClick();
                    }
                })
            }).catch(() => {
                console.log("取消")
            });
        }

        getData(){
            if(this.myChart){
                this.myChart.dispose();
            }
            this.myChart = echarts.init(this.$refs.chart1);
            rulesApi.count("").then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    const tableData = [
                        {name: "地方", value: rData.local},
                        {name: "国家", value: rData.country},
                    ]
                    this.myChart.setOption({
                        title: {
                            text: '规程规范总量'
                        },
                        tooltip: {},
                        color:[ '#08a4fa','#FF7A7A','#1869A0','#FF9393'],
                        series: [
                            {
                                name: '总量',
                                type: 'pie',
                                radius: '85%',
                                data: tableData,
                                itemStyle: {
                                    shadowBlur: 200,
                                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                                },
                                label: {
                                    normal: {
                                        // formatter: '{a|{a}}{abg|}\n{hr|}\n  {b|{b}：}{c}  {per|{d}%}  ',
                                        // formatter: '{a|{b}}\n{hr|}\n{per|{d}%}',
                                        formatter: '{a|{b}-{c}}',
                                        position: 'inner',
                                        rich: {
                                            a: {
                                                color: '#000',
                                                fontSize: 11,
                                                lineHeight: 20,
                                                align: 'center'
                                            },
                                            hr: {
                                                width: '100%',
                                                height: 0,
                                                alien:'center'
                                            },
                                            per: {
                                                color: '#000000',
                                                align: 'center',
                                                fontSize: 15,
                                            }
                                        }
                                    },
                                },
                                emphasis: {
                                    itemStyle: {
                                        shadowBlur: 10,
                                        shadowOffsetX: 0,
                                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                                    }
                                }
                            }
                        ]
                    });
                }
            })
        }
        getData2(){
            this.myChart = echarts.init(this.$refs.chart1);
            rulesApi.countReleaseYear().then(r => {
                if (r.data.result == 0) {
                    const rData = r.data.data;
                    const chartName = [];
                    const chartData1 = [];
                    const chartData2 = [];
                    for(const r of rData){
                        chartName.push(r.year);
                        chartData1.push(r.countType.local);
                        chartData2.push(r.countType.country);
                    }
                    this.myChart.setOption({
                        title: {
                            text: '年发布量'
                        },
                        tooltip: {},
                        xAxis: {
                            data: chartName
                        },
                        yAxis: {},
                        series: [
                            {
                                name: '地方',
                                type: 'bar',
                                data: chartData1,
                                itemStyle: {
                                    normal: {
                                        color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
                                            offset: 0,
                                            color: "#1268f3" // 0% 处的颜色
                                        }, {
                                            offset: 0.6,
                                            color: "#08a4fa" // 60% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: "#01ccfe" // 100% 处的颜色
                                        }], false)
                                    },
                                },
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //在上方显示
                                    textStyle: { //数值样式
                                        color: 'red',
                                        fontSize: 16
                                    },
                                    formatter:function (params:any) {
                                        if(params.value==0){  //为0时不显示
                                            return ''
                                        }else{
                                            return params.value
                                        }
                                    }
                                }
                            },
                            {
                                name: '国家',
                                type: 'bar',
                                data: chartData2,
                                itemStyle: {
                                    normal: {
                                        color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
                                            offset: 0,
                                            color: "#FF5B5B" // 0% 处的颜色
                                        }, {
                                            offset: 0.6,
                                            color: "#FF7A7A" // 60% 处的颜色
                                        }, {
                                            offset: 1,
                                            color: "#FF9B9B" // 100% 处的颜色
                                        }], false)
                                    },
                                },
                                label: {
                                    show: true, //开启显示
                                    position: 'top', //在上方显示
                                    textStyle: { //数值样式
                                        color: 'red',
                                        fontSize: 16
                                    },
                                    formatter:function (params:any) {
                                        if(params.value==0){  //为0时不显示
                                            return ''
                                        }else{
                                            return params.value
                                        }
                                    }
                                }
                            }
                        ]
                    });
                }
            })
        }

        //返回真实的type用于跳转或请求接口
        trueRulesType(){
            if(this.rulesType == '100' || this.rulesType == '101' || this.rulesType == '200'){
                return this.modeTypeChart;
            }else if(this.rulesType == '3'){
                return 2;
            }else{
                return this.rulesType;
            }
        }

        replaceTitle(title :string){
            return title.replace('管理','名称')
        }
    }
